"use client";

import { safeReturnPath } from "@/lib/safe-return-path";
import { useRef, useState, type ReactNode } from "react";

export function LogoutButton({ children = "退出登录", className, redirectTo }: { children?: ReactNode; className?: string; redirectTo?: string }) {
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function logout() {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError("");
    try {
      // Native form navigation can send Origin:null after a no-referrer page.
      // A same-origin fetch keeps origin validation without relaxing the API.
      const response = await fetch("/api/auth/logout", {
        method: "POST", mode: "same-origin", credentials: "same-origin",
        referrerPolicy: "same-origin", cache: "no-store", redirect: "follow",
      });
      if (!response.ok || !response.redirected) throw new Error("LOGOUT_FAILED");
      const destination = new URL(response.url);
      if (destination.origin !== window.location.origin) throw new Error("INVALID_REDIRECT");
      window.location.assign(redirectTo ? safeReturnPath(redirectTo) : destination.href);
    } catch {
      setError("退出未完成，请重试。");
      pending.current = false; setBusy(false);
    }
  }
  return <div>
    <button type="button" aria-label={typeof children === "string" ? children : "退出登录"} title={typeof children === "string" ? children : "退出登录"} className={className} disabled={busy} aria-busy={busy} onClick={() => void logout()}>{children}</button>
    {error && <p role="alert" className="mt-2 text-xs text-[var(--color-alert)]">{error}</p>}
  </div>;
}
